export default "__VITE_ASSET__xuT9yVB9__"